import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MasterDataCommon } from '../master-data.common';
import { MasterDataService } from 'src/app/services/master-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-manage-branch',
  templateUrl: './manage-branch.component.html',
  styleUrls: ['./manage-branch.component.css']
})
export class ManageBranchComponent implements OnInit {

  modalFormObjList:any;
  modalForm:any;
  modalStatus:any;
  formSubmitted=false;
  formErrors = MasterDataCommon.branchFormErrors;
  formValidationMessages = MasterDataCommon.branchFormValidationMessages;
  offDaysList=[{id:"2",name:"Monday"},{id:"3",name:"Tuesday"},{id:"4",name:"Wednesday"},{id:"5",name:"Thursday"},{id:"6",name:"Friday"},{id:"7",name:"Saturday"},{id:"1",name:"Sunday"}]

  constructor(private masterDataService:MasterDataService,private fb: FormBuilder,private modalService: NgbModal,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.initModalForm();
    this.loadBranch();
  }

  loadBranch(){
    this.masterDataService.getBranch()
    .subscribe(res => {
      console.log(res);
      this.modalFormObjList = res;
    });
  }

  initModalForm(){
    this.modalForm = this.fb.group({
      id:[''],
      name :  ['', [Validators.required]],
      contactNo :  ['', [Validators.required]],
      address :  ['', [Validators.required]],
      offDays :  ['', [Validators.required]],
    });
  }

  // Modal Code
  openModal(content,status) {
    this.modalStatus = status;
    if(!(this.modalStatus=='edit')){
      this.resetModalForm();
    }
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'md',windowClass : "animate__animated animate__slideInUp animate__faster"}).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  resetModalForm(){
    this.formSubmitted = false;
    this.modalForm.reset();
  }

  onDeleteClick(item){
    console.log(item);
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
       this.modalStatus = 'delete';
      this.masterDataService.deleteBranch(item.id)
      .subscribe(resp => {
        console.log(resp);
        this.changeModalFormObjList(item);
        this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','success');
      })
      }
    })
  }

  onSaveClick(){
    console.log(this.modalForm.value);
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.masterDataService.saveBranch(this.getValueFromModalForm())
      .subscribe(resp => {
        console.log(resp);
        this.closeModal();
        this.changeModalFormObjList(resp);
        this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
      })
    }
  }

  // ----------------------------
  compareItems(i1, i2) {
    return i1 && i2 && i1.id===i2.id;
  }

  getValueFromModalForm(){
   var jsonValue = {
    id:this.modalForm.value.id,
    name: this.modalForm.value.name,
    contactNo: this.modalForm.value.contactNo,
    address: this.modalForm.value.address,
    offDays:[]
   }

   this.modalForm.value.offDays.forEach(element => {
     jsonValue.offDays.push(element.id);
   });

   return JSON.stringify(jsonValue);

  }

  setValueToModalForm(modalObj){
    console.log(modalObj)
    this.modalForm.patchValue({
      id:modalObj.id,
      name: modalObj.name,
      contactNo: modalObj.contactNo,
      address: modalObj.address,
    });
    var selectedOffList=[]
    this.offDaysList.forEach(element1 => {
      modalObj.offDays.forEach(element2 => {
        if(element1.id==element2){
          selectedOffList.push(element1)
        }
      })
    });
    this.modalForm.controls.offDays.setValue(selectedOffList);
  }

  viewModalFormObj(formObj,content){
    this.masterDataService.viewBranch(formObj.id)
    .subscribe(resp => {
      console.log(resp);
      this.setValueToModalForm(resp);
      this.openModal(content,'edit');
    })
  }

  onEditClick(modalContent,formObj){
    console.log(formObj);
    this.viewModalFormObj(formObj,modalContent);
  }

  onUpdateClick(){
    console.log("this.modalForm",this.modalForm);
    console.log(this.modalForm.value);
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.masterDataService.updateBranch(this.getValueFromModalForm())
      .subscribe(resp => {
        console.log(resp);
        this.changeModalFormObjList(resp);
        this.closeModal();
        this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success');
      })
    }
  }

  //Setting
  changeModalFormObjList(modalFormObj){
    if(this.modalStatus=='add'){
      this.modalFormObjList.push(modalFormObj);
    }
    if(this.modalStatus=='edit'){
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1, modalFormObj);
    }
    if(this.modalStatus=='delete'){
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1);
    }
  }


  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

}
